export default __webpack_public_path__ + "static/yangolimg-3201e1e6002bd7207e693d0a5efb2014.png";